import CardCredentialIdentityScreen from 'features/cardManagement/screens/cardCredentialChallenge/CardCredentialIdentityScreen/CardCredentialIdentityScreen';
import React from 'react';

export default function MoveMoneyP2PCardCredentialIdentityPage() {
  return (
    <CardCredentialIdentityScreen
      otpPath="/move-money/p2p/credential-challenge/[cardId]/verify-otp"
      returnPath="/move-money/p2p/debit"
    />
  );
}
